<template lang="pug">
div
  .flex.flex-wrap
    BriqPriceInput.mr-S.mb-S(
      data-test-id="min-price-product-input"
      label="Minimum price"
      :step="0.01"
      v-model.number="product.MinimumPrice"
      :disabled="disabled"
      :currencySymbol="currencySymbol($locale, $currency)"
      @blur="vuelidate.product.MinimumPrice.$touch()"
      )
    BriqPriceInput.mr-S.mb-S(
      data-test-id="max-price-product-input"
      label="Maximum price"
      :step="0.01"
      v-model.number="product.MaximumPrice"
      :disabled="disabled"
      :currencySymbol="currencySymbol($locale, $currency)"
      @blur="vuelidate.product.MaximumPrice.$touch()"
      )
  .validation-message(data-test-id='min-max-product-price-error') {{ minMaxProductPriceError }}
</template>

<script>
import BriqPriceInput from '@v/components/BriqPriceInput.vue'
import { currencySymbol } from '@/helpers/intlFormatter.js'

export default {
  name: 'MinMaxProductPrice',
  components: { BriqPriceInput },
  props: {
    product: { type: Object, required: true },
    disabled: Boolean,
    vuelidate: { type: Object, required: true },
  },
  data() {
    return {
      expandedDeals: [],
    }
  },
  computed: {
    minMaxProductPriceError() {
      return this.vuelidate.product?.MaximumPrice?.$error
        ? 'Maximum price should be equal or greater than minimum price'
        : ''
    },
  },
  methods: { currencySymbol },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'
</style>
